export default {
	"dashboard": {
		"all": "ทั้งหมด",
		"own": "ของตนเอง",
		"noConfirm": "รอยืนยัน",
		"noPlan": "รอจัดสายงาน",
		"distribution": "การจัดส่ง",
		"distributionPlan": "แผนการจัดส่ง",
		"noDispatch": "รอจ่ายงานคนขับ",
		"execute": "การดำเนินงานของคนขับ",
		"pending": "ที่ยังดำเนินการ",
		"tempMonitor": "การติดตามอุณหภูมิ",
		"monitoringRate": "อัตราการควบคุม",
		"tempUpToStandard": "เป็นไปตามมาตรฐาน",
		"upToStandardRate": "อัตราการปฏิบัติตามข้อกำหนด",
		"timeUpToStandard": "เป็นไปตามข้อกำหนดด้านเวลา",
		"today": "วันนี้",
		"yesterday": "เมื่อวาน",
		"clickMarkRead": "คลิ๊กเพื่อทำเครื่องหมายว่าอ่านแล้ว",
		"doubleClickToTeadMore": "คลิ๊กสองครั้งเพื่ออ่านเนื้อหาเฉพาะเจาะจง",
		"noWarningMessage": "ยังไม่มีข้อความแจ้งเตือน",
		"noRemindMessage": "ยังไม่มีข้อความเตือน",
		"noNoticeMessage": "ยังไม่มีข้อความแจ้ง",
		"gotIt": "เข้าใจแล้ว",
		"clickDownload": "คลิ๊กเพื่อดาวน์โหลด",
		"quotation": "ใบเสนอราคา",
		"trunkLinePlan": "แผนการขนส่งระหว่างคลังสินค้า",
		"transportPlan": "แผนการจัดส่ง",
		"refreshInSeconds": "จะรีเฟรชข้อมูล",
		"shippingOrder": "คำสั่งขนส่งสินค้า",
		"plan": "จัดสายงาน",
		"schedule": "จ่ายงานคนขับ",
		"abnormal": "สินค้า/งานที่ผิดปกติ",
		"receipt": "ใบเสร็จรับเงิน",
		"notPickedUp": "รอเข้ารับสินค้า",
		"undelivered": "รอจัดส่งสินค้า",
		"driver": "พนักงานขับรถ",
		"new": "รายการใหม่",
		"shipments": "สินค้า",
		"vehicle": "รถ",
		"null": "ไม่มี",
		"NoTrackingInformation": "ไม่มีข้อมูลสำหรับการติดตาม",
		"from": "จาก",
		"to": "ถึง",
		"displayOnlyActiveJobs": "แสดงเฉพาะงานที่กำลังดำเนินการ",
		"jobOnTheWay": "งาน_ระหว่างจัดส่ง",
		"jobHandingOver": "งาน_กำลังส่งสินค้า",
		"waitingForAccept": "ยังไม่กดรับงาน",
		"notArriveOrigin": "ยังไม่ถึงคลังต้นทาง",
		"waitingForPickingUp": "ยังไม่รับสินค้าต้นทาง",
		"waitingForDeparture": "ยังไม่ออกเดินทาง",
		"notArriveDestination": "ยังไม่ถึงคลังปลายทาง",
		"waitingForUnloading": "ยังไม่ลงสินค้า",
		"waitingForDelivering": "ยังไม่ส่งสินค้าสำเร็จ",
		"deliverySummary": "สรุปภาพรวมการจัดส่ง",
		"noIssue": "ไม่พบปัญหา",
		"nearDue": "เฝ้าระวัง",
		"overdue": "เลยเวลา",
		"totalCreated": "สร้างทั้งหมด",
		"delivered": "ส่งสินค้าแล้ว",
		"notAssigned": "ยังไม่จ่ายงาน",
		"incident": "เจอปัญหา",
		"newAbnormal": "ใหม่",
		"pending": "รอดำเนินการ",
	}
}


// WEBPACK FOOTER //
// ./src/lang/th/pages/dashboard/dashboard.js